import { Label } from ".";
import { classNames } from "../../utils/helpers";

export default function NumberInput({
  label,
  subLabel,
  name,
  placeholder = "",
  required = false,
  value,
  min,
  max,
  onChange,
}) {
  return (
    <>
      {/* Label/required asterisk */}
      {label && <Label label={label} required={required} />}
      <div className={classNames("flex relative", label ? "mt-1" : "")}>
        {/* Input */}
        <input
          type="number"
          name={name}
          className="p-2 rounded-md shadow-md focus:outline-none block w-full sm:text-sm border-gray-300 placeholder-gray-300"
          placeholder={placeholder}
          required={required}
          value={value}
          min={min}
          max={max}
          onChange={onChange}
          readOnly={!onChange}
          autoComplete="off"
        />
      </div>
      {/* Sublabel */}
      {subLabel && (
        <div className="mt-1 text-gray-400 text-xs text-right">{subLabel}</div>
      )}
    </>
  );
}
